// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const externalIntegrationService = {
    getAll,
    getById,
    add,
    update,
    deleteEntity
};

function getAll() {
    // return axios.get(`/externalintegrations/?accountId=${accountId}`).then(handleResponse);
    return axios.get(`/externalintegrations/`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/externalintegrations/${id}`).then(handleResponse);
}

function add(externalIntegration) {
    return axios.post('/externalintegrations', externalIntegration).then(handleResponse);
}

function update(externalIntegration) {
    return axios.put(`/externalintegrations/${externalIntegration.externalIntegrationId}`, externalIntegration).then(handleResponse);
}

function deleteEntity(externalIntegration) {
    return axios.delete(`/externalintegrations/${externalIntegration.externalIntegrationId}`).then(handleResponse);
}
